export const experiences = [
    {
        "title": "Freelancing",
        "start": "March 2020",
        "end": "Present",
        "location": "San Francisco, California",
        "descrption": "Developing Web and Mobile Applications",
        "skills": ["React", "Redux", "Thunk", "Saga", "MongoDB", "HTML5", "CSS3", "SwiftUI", "Firebase DB"]
    },
    {
        "title": "Software Engineer at Glidewell Detnal Lab",
        "start": "May 2019",
        "end": "March 2020",
        "location": "Irvine, California",
        "descrption": "Maintained and developed micro-services and front-end applications for Glidewell lab management, order management and order shipping using .NET Core, Angular, React, Redux, RabbitMQ, MongoDB.",
        "skills": [".NET Core", "Angular", "React", "Redux", "RabbitMQ", "MongoDB", "HTML5", "CSS3"]
    }, 
    {
        "title": "BI Developer at Glidewell Detnal Lab",
        "start": "September 2018",
        "end": "May 2019",
        "location": "Irvine, California",
        "descrption": "Migrated part of the company’s old ETL processes hosted in Pentaho involving reading company’s internal software systems’ data from different RESTful APIs and pushing it (after proper pre-processing and conversion) into various data stores including Amazon S3, Redshift and RDS by developing or enhancing numerous lambda functions written in Python and instantiating new Amazon Data Pipeline instances.",
        "skills": ["Python", "REST API", "AWS Services", "ETL"]
    },
    {
        "title": "Data Engineer Intern at Glidewell Detnal Lab",
        "start": "July 2018",
        "end": "September 2019",
        "location": "Irvine, California",
        "descrption": "Maintained Node.js projects and developed responsive UI for Glidewell Executive Dashboard using AngularJS+Bootstrap.",
        "skills": ["Node.js", "AngularJs", "Bootstrap", "HTML5", "CSS3"]
    },
    {
        "title": "Research Assistant at BGSU",
        "start": "July 2017",
        "end": "May 2018",
        "location": "Bowling Green, Ohio",
        "descrption": "Kidney Transplat Failure Prediction by Neural Network Model",
        "skills": ["Python", "Pandas", "Scikit-learn", "Keras", "Machine Learning"]
    }

]